 
const serverSrc='https://yetom.api.3dh5.vip';
//const serverSrc='';
 
  export default
  {
    serverSrc,//服务器地址
  }
 